// Compare Locations TOOL
export const CompareLocations = {
  GET_COMPARE_LOCATION_SUMMARY: "GET_COMPARE_LOCATION_SUMMARY",
  GET_COMPARE_LOCATION_SUMMARY_SUCCESS: "GET_COMPARE_LOCATION_SUMMARY_SUCCESS",
  GET_COMPARE_LOCATION_SUMMARY_FAILURE: "GET_COMPARE_LOCATION_SUMMARY_FAILURE",
  // Clear Data
  CLEAR_COMPARE_LOCATION_SUMMARY: "CLEAR_COMPARE_LOCATION_SUMMARY",
};
